import React from 'react';
import './Title.css';
const Title = () => {
  return (
    <div className='title'>
      <h1 className='title__header'>Foodgram</h1>
      <p className='title__heading'>
        <strong> The one stop food gallery, for all your munchy needs.</strong>
      </p>
    </div>
  );
};

export default Title;
